module.exports = __webpack_public_path__ + "img/1723132933238-cake.jpeg.11bb2d3e.webp";